<template>
  <simple-item-form
      ref="itemForm"
      :initItem="initItem"
      :successMsg="t('itemWasCreated')"
      :submitAction="submit"
      :enableClearForm="true"
      :clearFormOnSubmit="true"
  />
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import SimpleItemForm from './SimpleItemForm.vue'

// models
import Item from '@/models/inventory/Item'
import {useI18n} from 'vue-i18n'
import {UploadUserFile} from "element-plus";

interface Option {
  name: string
  values: string[]
}

export default defineComponent({
  components: {SimpleItemForm},
  name: 'new-item',

  setup() {
    const {t} = useI18n({
      messages: {
        en: {itemWasCreated: 'Item was created successfully'},
        ar: {itemWasCreated: 'تم انشاء المنتج بنجاح'}
      }
    })
    return {t}
  },

  data() {
    return {
      initItem: new Item(),
      isSaving: false
    }
  },

  methods: {
    async submit(data: {
      item: any,
      variants: any,
      images: Array<{
        isDefault: boolean,
        data: UploadUserFile
      }>,
      variantImages: Array<Array<{
        isDefault: boolean,
        data: UploadUserFile
      }>>
    }) {
      try {
        this.isSaving = true
        const formData = new FormData()
        formData.set("body", JSON.stringify({
          item: data.item,
          variants: data.variants
        }));
        data.images.forEach(i => {
          formData.append("images", i.data.raw);
          formData.append("isDefaults", i.isDefault);
        })

        data.variantImages.forEach((value, index) => {
          value.forEach(i => {
            formData.append(`variantImages${index}`, i.data.raw);
            formData.append(`variantImageIsDefaults${index}`, i.isDefault);
          })
        })

        await this.$http.post<Item>(Item.ENDPOINT, formData)
        await this.$router.push(this.$Route.INVENTORY_ITEMS)
      } catch (error) {
        console.log(error)
        this.isSaving = false
        return error
      }
    }
  },

  // Navigation guard to check child component's dirty state
  beforeRouteLeave(to: any, from: any, next: any) {
    // Skip confirmation if user clicked save button
    if (this.isSaving) {
      next()
      return
    }

    const itemForm = this.$refs.itemForm as any
    if (itemForm && itemForm.formIsDirty) {
      const answer = window.confirm(
        this.$ctx.locale === 'ar'
          ? 'لديك تغييرات غير محفوظة. هل تريد المغادرة؟'
          : 'You have unsaved changes. Are you sure you want to leave?'
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
})
</script>
